const staleTime = 5 * 60 * 1000;
const cacheTime = 10 * 60 * 1000;

export const cachingConfig = {
  staleTime,
  cacheTime,
};

export const queryConfig = {
  retry: false,
  refetchOnWindowFocus: false,
  caching: cachingConfig,
};

export const mutationConfig = {
  retry: false,
};

export const defaultOptions = {
  queries: queryConfig,
  mutations: mutationConfig,
};
